export const HIGHEST = 'highest';
export const ASSIGNED = 'assigned';
export const VOLUNTARY = 'voluntary';
export const ACCURACY_SUB_FILTER = 'ACCURACY_SUB_FILTER';
export const PROGRESS_SUB_FILTER = 'PROGRESS_SUB_FILTER';
